import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { CheckCircle2 } from "lucide-react";
import { api } from "@/api";
import { useAuth } from "@/auth";
import { C } from "@/theme";
import { Modal, Field, Button } from "@/ui";

export function ChangePasswordModal({ open, onClose }) {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const [cp, setCp] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const reset = () => { setCur(""); setNp(""); setCp(""); setErr(""); setDone(false); };
  const close = () => { reset(); onClose(); };

  const mut = useMutation({
    mutationFn: () => api.post("/auth/change-password", { role: user?.role, user_id: user?.id, current_password: cur, new_password: np }),
    onSuccess: () => { setDone(true); setErr(""); },
    onError: (e) => setErr(e.message),
  });

  const submit = () => {
    setErr("");
    if (np.length < 6) return setErr("New password must be at least 6 characters");
    if (np !== cp) return setErr("New passwords do not match");
    mut.mutate();
  };

  return (
    <Modal open={open} onClose={close} title="Change password" testID="change-password-modal">
      {done ? (
        <div className="flex flex-col items-center text-center gap-3 py-2">
          <CheckCircle2 size={44} color={C.success} />
          <p style={{ color: C.onSurface }} className="font-extrabold">Password updated</p>
          <p style={{ color: C.muted }} className="text-[13px]">Use your new password next time you sign in.</p>
          <div className="w-40"><Button label="Done" testID="cp-done" onClick={close} /></div>
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          <Field label="Current password" type="password" value={cur} onChange={setCur} testID="cp-current" />
          <Field label="New password" type="password" value={np} onChange={setNp} testID="cp-new" />
          <Field label="Confirm new password" type="password" value={cp} onChange={setCp} testID="cp-confirm" />
          {err ? <p data-testid="cp-error" style={{ color: C.error }} className="text-[13px] font-semibold">{err}</p> : null}
          <Button label="Update password" testID="cp-submit" loading={mut.isPending} disabled={!cur || !np || !cp} onClick={submit} />
        </div>
      )}
    </Modal>
  );
}
